module.exports = __webpack_public_path__ + "static/media/logo.de303bab.svg";